import { Button, Form, Input, message, Space, Row,
  Col } from 'antd'
import { useState, Fragment, useImperativeHandle } from 'react'
import { Modal } from 'antd'
import User from '@/modules/user'
import CountDownBtn from '@/components/countDownBtn'
import styles from './forget.scss'

const ForgetForm = (props) => {
  // 属性
  const { handleFindSuccess } = props
  const [forgetModalVisible, handleModalVisible] = useState(false)
  const [form] = Form.useForm()
  // 用户初始化
  const user = new User()

  const layout = {
    labelCol: { span: 5 },
    wrapperCol: { span: 19 }
  }

  const midLayout = {
    wrapperCol: { offset: 1, span: 24 }
  }

  const tailLayout = {
    wrapperCol: { offset: 8, span: 16 }
  }

  // 用useImperativeHandle暴露一些外部ref能访问的属性
  useImperativeHandle(props.onRef, () => {
    return {
      open
    }
  })
  const open = (value) => {
    form.setFieldsValue({ phone: value })
    handleModalVisible(true)
  }

  // 处理找回密码
  const onFinish = async(values) => {
    user.findPwd(values).then(()=>{
      message.success('找回成功')
      handleModalVisible(false)
      handleFindSuccess && handleFindSuccess()
    }).catch((err)=>{
      console.log('error', err)
    })
  }

  const handleSend = () => {
    const { phone } = form.getFieldsValue(true)
    console.log('phonephone', phone)
    return checkPhoneValue(phone).then(()=>{
      user.sendCode({ phone })
      return Promise.resolve()
    }).catch((err)=>{
      return Promise.reject(err)
    })
  }

  const passwordValid = ({ getFieldValue }) => ({
    validator(_, value) {
      if (!value) {
        return Promise.reject(new Error('请再次输入密码'))
      }
      if (!value || getFieldValue('pwd') === value) {
        return Promise.resolve()
      }
      return Promise.reject(new Error('两次输入密码不一致!'))
    }
  })

  const validatePwd = () => ({
    validator(_, value) {
      if (value) {
        const reg = new RegExp('^(?![A-Z]*$)(?![a-z]*$)(?![0-9]*$)(?![^a-zA-Z0-9]*$)\\S+$')
        const cnReg = new RegExp('[\\u4E00-\\u9FFF]+', 'g')
        if (value && (value.length < 8 || value.length > 35)) {
          return Promise.reject(new Error('请输入8到35位的密码'))
        }
        if (!(reg.test(value)) || (cnReg.test(value))) {
          return Promise.reject(new Error('密码需大小写字母、数字、字符两种及以上组合'))
        } else {
          return Promise.resolve()
        }
      } else {
        return Promise.reject('请输入密码')
      }
    }
  })

  const checkPhoneValue = async(value)=>{
    if (['', undefined].includes(value)) {
      return Promise.reject(new Error('请输入手机号!'))
    }
    if (value && value.length !== 11) {
      return Promise.reject(new Error('请输入11位的手机号!'))
    }
    if (!Number.isInteger(value - 0)) {
      return Promise.reject(new Error('请输入正确格式的手机号!'))
    }
    return Promise.resolve()
  }

  return (
    <Fragment>
      <Modal
        destroyOnClose
        centered
        title='用户找回密码'
        visible={forgetModalVisible}
        onCancel={() => handleModalVisible(false)}
        footer={null}
        width={460}
      >
        <Form
          form={form}
          onFinish={onFinish}
          {...layout}
          name='normal_register'
          className={styles['login-form']}
        >
          <Form.Item
            label='手机号'
            name='phone'
            rules={[{ required: true, message: '手机号不能为空' }]}
          >
            <Input disabled placeholder='请输入手机号' />
          </Form.Item >
          <Form.Item {...midLayout} style={{ marginBottom: 0 }}>
            <Row gutter={8}>
              <Col span={17}>
                <Form.Item label='验证码' name='code' rules={[{ required: true, message: '验证码不能为空' }]}
                >
                  <Input placeholder='请输入验证码' />
                </Form.Item>
              </Col>
              <Col span={6}>
                <div style={{ width: '110%' }}>
                  <CountDownBtn handleSend={handleSend}/>
                </div>
              </Col>
            </Row>

          </Form.Item>
          <Form.Item
            label='新密码'
            name='pwd'
            rules={[
              validatePwd
            ]}
          >
            <Input.Password onCopy={(e) => e.preventDefault()} placeholder='请输入8-35位字符登录密码'
            />
          </Form.Item>
          <Form.Item
            label='确认密码'
            name='cPassword'
            rules={[
              passwordValid
            ]}
          >
            <Input.Password onCopy={(e) => e.preventDefault()} placeholder='请再次确认密码'
            />
          </Form.Item>

          <Form.Item {...tailLayout}>
            <Space>
              <Button onClick={() => handleModalVisible(false)} >
                  取消
              </Button>
              <Button type='primary' htmlType='submit' >
                  提交
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Modal>
    </Fragment>
  )
}

export default ForgetForm
